module.exports = __webpack_public_path__ + "img/graphic_design_side_image.da5df117.jpg";